// src/components/SideMenu.js
import React from 'react';
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Button
} from '@mui/material';
import { ChevronRight, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTheme as useCustomTheme } from '../context/ThemeContext';
import { useTheme } from '@mui/material/styles';

const SideMenu = ({
                      menuItems = [],
                      selectedItem = null,
                      onItemClick = () => {},
                      onItemHover = () => {},
                      programsCount = 0,
                      userName = 'Корисник'
                  }) => {
    const theme = useTheme();
    const { isDarkMode } = useCustomTheme();
    const navigate = useNavigate();

    const handleHomeClick = () => {
        navigate('/user-dashboard');
    };

    return (
        <Box sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'background.paper'
        }}>
            {/* Header */}
            <Box sx={{ p: { xs: 2, md: 3 }, borderBottom: 1, borderColor: 'divider' }}>
                <Typography variant="h5" sx={{
                    color: 'primary.main',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: { xs: '1.1rem', md: '1.5rem' }
                }}>
                    👋 Добредојдовте!
                </Typography>
                <Typography variant="body2" sx={{
                    color: 'text.secondary',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    mt: 1,
                    fontSize: { xs: '0.8rem', md: '0.875rem' }
                }}>
                    {userName}
                </Typography>

                <Button
                    fullWidth
                    variant="contained"
                    startIcon={<Home />}
                    onClick={handleHomeClick}
                    sx={{
                        mt: 2,
                        backgroundColor: 'primary.main',
                        color: 'white',
                        fontWeight: 'bold',
                        py: 1.5,
                        borderRadius: 2,
                        fontSize: { xs: '0.85rem', md: '0.95rem' },
                        '&:hover': {
                            backgroundColor: 'primary.dark',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 4px 12px rgba(255, 126, 185, 0.4)'
                        },
                        transition: 'all 0.3s ease'
                    }}
                >
                    🏠 Дома
                </Button>
            </Box>

            {/* Menu Items */}
            <List sx={{ p: 0, flex: 1 }}>
                {menuItems.map((item, index) => (
                    <ListItem
                        key={item.id}
                        onClick={() => onItemClick(item)}
                        onMouseEnter={() => onItemHover(item)}
                        sx={{
                            cursor: 'pointer',
                            py: { xs: 1.5, md: 2 },
                            px: { xs: 2, md: 3 },
                            borderBottom: index < menuItems.length - 1 ? 1 : 0,
                            borderColor: 'divider',
                            transition: 'all 0.3s ease',
                            position: 'relative',
                            opacity: item.available ? 1 : 0.7,
                            '&:hover': {
                                backgroundColor: item.available
                                    ? `${item.color}15`
                                    : isDarkMode ? '#2a2a2a' : '#f5f5f5',
                                transform: item.available ? 'translateX(8px)' : 'none',
                                '& .menu-arrow': {
                                    opacity: 1,
                                    transform: 'translateX(0px)',
                                }
                            }
                        }}
                    >
                        <Box sx={{
                            position: 'absolute',
                            left: 0, top: 0, bottom: 0,
                            width: '4px',
                            backgroundColor: item.color,
                            opacity: selectedItem?.id === item.id ? 1 : 0,
                            transition: 'opacity 0.3s ease'
                        }} />

                        <ListItemIcon sx={{
                            color: item.color,
                            minWidth: { xs: 32, md: 40 },
                            mr: { xs: 1, md: 1.5 }
                        }}>
                            {React.cloneElement(item.icon, {
                                sx: { fontSize: { xs: 20, md: 24 }, fontWeight: 'bold' }
                            })}
                        </ListItemIcon>

                        <ListItemText
                            primary={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body1" sx={{
                                        color: 'text.primary',
                                        fontWeight: 'bold',
                                        fontSize: { xs: '0.85rem', md: '0.95rem' }
                                    }}>
                                        {item.title}
                                    </Typography>
                                    <Chip
                                        label={item.badge}
                                        size="small"
                                        sx={{
                                            bgcolor: item.available ? item.color : '#666',
                                            color: item.color === '#ffd166' ? '#000' : 'white',
                                            fontWeight: 'bold',
                                            fontSize: { xs: '0.55rem', md: '0.6rem' },
                                            height: { xs: '16px', md: '18px' }
                                        }}
                                    />
                                </Box>
                            }
                        />

                        <ChevronRight
                            className="menu-arrow"
                            sx={{
                                color: item.color,
                                opacity: 0,
                                transform: 'translateX(-10px)',
                                transition: 'all 0.3s ease',
                                fontSize: 20,
                                fontWeight: 'bold',
                                display: { xs: 'none', md: 'block' }
                            }}
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default SideMenu;